import * as z from 'zod';
export const ImageRefSchema = z.object({
    src: z.url(),
    alt: z.string(),
    imageId: z.string().optional().meta({
        description: 'Kaleido ID (for cropper/derivates)',
    }),
    bildebankenId: z
        .string()
        .optional()
        .meta({ description: 'Bildebanken ID (for detail view)' }),
    crop: z
        .object({
        x: z.number().min(0).max(1),
        y: z.number().min(0).max(1),
        w: z.number().min(0).max(1),
        h: z.number().min(0).max(1),
    })
        .optional(),
});
export const PublicImageRefSchema = z.object({
    src: z.url(),
    alt: z.string(),
});
export const BildebankenDerivateQuerySchema = z.object({
    imageId: z.string().min(1).meta({ example: '91y7ifT90i1zn_tzN8z_rg' }),
    width: z.coerce.number().int().positive().optional().meta({ example: 2000 }),
    height: z.coerce.number().int().positive().optional(),
    format: z.enum(['jpg', 'webp', 'png']).optional(),
    x: z.coerce.number().min(0).max(1).optional(),
    y: z.coerce.number().min(0).max(1).optional(),
    w: z.coerce.number().min(0).max(1).optional(),
    h: z.coerce.number().min(0).max(1).optional(),
});
export const BildebankenDerivateResponseSchema = z.object({
    location: z.url(),
});
//# sourceMappingURL=bildebanken.js.map